import { Component, OnDestroy, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash';
import { FormBuilderBasicInputComponentModel } from '../../models/form-builder-basic-input-component-model';

@Component({
  selector: 'tf-core-fb-basic-input-checklist-input',
  templateUrl: './fb-basic-input-checklist-input.component.html',
  styleUrls: ['./fb-basic-input-checklist-input.component.css']
})
export class FbCoreBasicInputChecklistInputComponent extends FormBuilderBasicInputComponentModel implements OnInit, OnDestroy {
    public data = {
        component: null,
        editorData: '',
        editorActive: false,
        hasChanges: false,
        sectionActive: false,
        viewType: 'default',
        toggleTooltips: false,
        formGroup: null,
        controlName: ''
    };

    private _columnSpan: any[];

    get columnSpan(): any[] {
        this.setUpColumns();

        return this._columnSpan;
    }

    set columnSpan(value: any[]) {
        this._columnSpan = value;
    }

    public activeEl: number;


    constructor(
    ) {
        super();
    }

    ngOnInit(): void {
        super.init();

        this.init();

    }

    ngOnDestroy(): void {
    }

    init(): void {
        this.setUpColumns();
    }

    get columns(): number {
        return this.data.component.columns;
    }

    get layout(): string {
        return this.data.component.layout;
    }

    get contentHeadings(): any[] {
        return this.data.component.contentHeadings.slice(0, this.columns);
    }

    get contentRows(): any[] {
        return this.data.component.contentRows;
    }

    public handleAddRowClick(event: MouseEvent): void {
        event.stopPropagation();

        const lastItemClone = cloneDeep(this.data.component.contentRows[(this.data.component.contentRows.length - 1)]);
        
        this.data.component.contentRows.push(lastItemClone);
    }

    public handleHeadingsClick(event: MouseEvent): void {
        if (this.data.sectionActive !== true) {
            return;
        }

        event.stopPropagation();

        this.activeEl = -1;

    }

    public handleRowClick(event: MouseEvent, row: any[]): void {
        if (this.data.sectionActive !== true) {
            return;
        }

        event.stopPropagation();

        this.contentRows.map((item, index) => {
            if (item === row) {
                this.activeEl = index;
            }
        });

    }

    public setUpColumns(): void {
        switch (this.columns) {
            case 2:
                this.columnSpan = [ 12, 12, 12, 12 ];

                if (this.layout === '70-30') {
                    this.columnSpan = [ 16, 8, 12, 12 ];
                    
                    break;
                }

                if (this.layout === '30-70') {
                    this.columnSpan = [ 8, 16, 12, 12 ];

                    break;
                }
                break;
            case 3:
                this.columnSpan = [ 8, 8, 8, 12 ];

                if (this.layout === '50-25-25') {
                    this.columnSpan = [ 12, 6, 6, 12 ];
                }
                break;
            case 4:
                this.columnSpan = [ 6, 6, 6, 6 ];

                if (this.layout === '40-20-20-20') {
                    this.columnSpan = [ 9, 5, 5, 5 ];
                }
                break;
        }
    }

    public handleColumnTypeChange(type: string, row: any, col: any): void {
        this.resetColumnToDefaults(type, col);

    }

    public resetColumnToDefaults(type: string, col: any): void {
        col.content = undefined;
        col.placeholder = undefined;
        col.placeholder2 = undefined;
        col.number = undefined;
        col.options = undefined;

        switch (type) {
            case 'label':
                col.content = 'Your text goes here';
                break;
            case 'text':
                col.placeholder = 'Placeholder text';
                break;
            case 'date':
                col.placeholder = 'DD/MM/YYYY';
                break;
            case 'date_from_and_to':
                col.placeholder = 'DD/MM/YYYY';
                col.placeholder2 = 'DD/MM/YYYY';
                break;
            case 'rate':
                col.number = 5;
                break;
            case 'single_select':
                col.options = [
                    {
                        label: "Option 1"
                    },
                    {
                        label: "Option 2"
                    }
                ];
                break;
        }
    }

}
